import { defineComponent as _defineComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'UiPrivacyPolicy',
  props: {
  text: {
    type: String,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const privacyPolicyUrl = window.privacyPolicyUrl
const termsOfUseUrl = window.termsOfUseUrl

const props = __props

const __returned__ = { privacyPolicyUrl, termsOfUseUrl, props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})